import React from 'react';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { Button, Checkbox, Dropdown, Input, Modal, Popover, Tooltip } from 'antd';
import { PATH } from 'constants/path';
import AvaIcon from 'assets/common/ava.png';
import { useNavigate } from 'react-router-dom';
import ProviderStore from 'store/Provider';
import SubscriptionStore from 'store/Subscription';
import { setHasShowAvaSettingInbox, getHasSkipGreetings, setHasSkipGreetings } from 'utils/localstore';
import HomeStore from 'store/Home';
import Frame from './imgs/frame.png';
import AvaConfigHome from './AvaConfigHome';
import { isFreeUser, shouldShowKlarityPlanUI } from 'utils/provider';
import MessageContainer from './MessageContainer';
import AIChat from 'components/AIChat';
import ThumbsUpIcon from './imgs/thumd.png';
import { EAIChatPageId } from 'types/ai';
import R1Img from './imgs/r1.png';
import R2Img from './imgs/r2.png';
import R3Img from './imgs/r3.png';
import GreetingSetUpModal from './GreetingSetUpModal';
import useCurrentUser from 'hooks/useCurrentUser';
import { canShowGroupPracticeView } from 'utils/common';
import useAllTeamMember from 'hooks/group/useAllTeamMember';
import { ERoleCode } from 'types/enumItems';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';

const InboxPage = () => {
    const [showGreetBanner, setShowGreetBanner] = React.useState(!getHasSkipGreetings());
    const [getSubscription] = SubscriptionStore.useStore();
    const [clickSendMsgFlag, setClickSendMsgFlag] = React.useState<{}>();
    const currentPlan = getSubscription('currentPlan');
    const [showGreetingSetUpModal, setShowGreetingSetUpModal] = React.useState(false);

    const navigate = useNavigate();

    const [showAvaModal, setShowAvaModal] = React.useState(false);
    const [showAvaHome, setShowAvaHome] = React.useState(false);

    const [getUser] = ProviderStore.useStore();
    const user = getUser('data');
    const loadingUser = getUser('loading');
    const loadingPlan = getSubscription('loading');
    const [getHomeSore] = HomeStore.useStore();
    const homeInfo = getHomeSore('data');
    const hasPlan = !isFreeUser() || shouldShowKlarityPlanUI(homeInfo);
    const uuid = user?.providerUid;
    // PPV 与 home.klarityUser 一致（同 PPALayout）
    const isPPVProvider = !!homeInfo?.klarityUser;
    const canUseAva = !!(homeInfo && (!homeInfo.freeUser || homeInfo.ppaProvider || isPPVProvider));
    const [currentUser] = useCurrentUser();
    const showGroupPracticeView = canShowGroupPracticeView(currentUser);
    const [showTipsForSetting, setShowTipsForSetting] = React.useState(false);
    const [teamMembers] = useAllTeamMember();
    const providerMembers = React.useMemo(
        () => teamMembers?.filter((m) => m.roleCode === ERoleCode.GROUP_PROVIDER) || [],
        [teamMembers],
    );
    const [providerPickerOpen, setProviderPickerOpen] = React.useState(false);
    const [providerSearchQuery, setProviderSearchQuery] = React.useState('');
    const [selectedProviderIdForView, setSelectedProviderIdForView] = React.useState<number>();

    const filteredProviders = providerMembers.filter((p) => {
        if (!providerSearchQuery) return true;
        const name = `${p.firstName} ${p.lastName}`.toLowerCase();
        return name.includes(providerSearchQuery.toLowerCase());
    });

    const selectedProviderForView = providerMembers.find((p) => p.providerId === selectedProviderIdForView);

    const isActingMyself = currentUser?.actingMode === 'SELF';
    const disabledSendToPatient = !isActingMyself && currentUser?.roleCode === ERoleCode.GROUP_OWNER;

    const handleSkip = () => {
        setHasSkipGreetings(true);
        setShowTipsForSetting(true);
        setShowGreetBanner(false);
        setShowGreetingSetUpModal(false);
    };

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.left}>
                    <h1>Messages</h1>
                </div>
                <div className={s.right}>
                    {/* {showGroupPracticeView && (
                        <Popover
                            open={providerPickerOpen}
                            onOpenChange={setProviderPickerOpen}
                            trigger="click"
                            placement="bottomRight"
                            content={
                                <div className={s.providerPicker}>
                                    <div className={s.providerPickerTitle}>Switch to provider view</div>
                                    <Input
                                        prefix={<SearchOutlined style={{ color: '#9CA3AF' }} />}
                                        placeholder="Search providers..."
                                        value={providerSearchQuery}
                                        onChange={(e) => setProviderSearchQuery(e.target.value)}
                                        className={s.providerPickerSearch}
                                    />
                                    <div className={s.providerPickerList}>
                                        {filteredProviders.map((p) => (
                                            <div
                                                key={p.id}
                                                className={`${s.providerPickerItem} ${
                                                    p.providerId === selectedProviderIdForView
                                                        ? s.providerPickerItemActive
                                                        : ''
                                                }`}
                                                onClick={() => {
                                                    setSelectedProviderIdForView(p.providerId || undefined);
                                                    setProviderPickerOpen(false);
                                                    setProviderSearchQuery('');
                                                }}
                                            >
                                                <div className={s.providerPickerAvatar}>
                                                    {(p.firstName?.[0] || '') + (p.lastName?.[0] || '')}
                                                </div>
                                                <div className={s.providerPickerInfo}>
                                                    <div className={s.providerPickerName}>
                                                        {p.firstName} {p.lastName}
                                                    </div>
                                                </div>
                                                {p.providerId === selectedProviderIdForView && (
                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                        <path
                                                            d="M12.5 3.75L5.625 10.625L2.5 7.5"
                                                            stroke="#0E62F4"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                )}
                                            </div>
                                        ))}
                                        {filteredProviders.length === 0 && (
                                            <div className={s.providerPickerEmpty}>No providers found</div>
                                        )}
                                    </div>
                                </div>
                            }
                        >
                            <Button style={{ marginRight: '12px' }} icon={<EyeOutlined />}>
                                {selectedProviderForView
                                    ? `${selectedProviderForView.firstName} ${selectedProviderForView.lastName}`
                                    : 'Select provider'}
                            </Button>
                        </Popover>
                    )} */}
                    {canUseAva && (
                        <Popover
                            open={showTipsForSetting}
                            rootClassName={s.settingPopWrap}
                            content={
                                <div className={s.settingPop}>
                                    <p>Edit or update your greeting messages anytime in “Settings”.</p>
                                    <span
                                        onClick={() => {
                                            setShowTipsForSetting(false);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M6 18L18 6M6 6L18 18"
                                                stroke="#111827"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                </div>
                            }
                        >
                            <Button
                                style={{ marginRight: '12px' }}
                                onClick={() => {
                                    navigate(`${PATH.DASHBOARD}/${PATH.AVA_SETTING}?from=inbox`);
                                }}
                            >
                                Settings
                            </Button>
                        </Popover>
                    )}
                    <Tooltip
                        title={
                            disabledSendToPatient
                                ? 'You are viewing other providers’ messages. Please switch to your own view to send messages.'
                                : ''
                        }
                    >
                        <Button
                            type="primary"
                            disabled={disabledSendToPatient}
                            onClick={() => {
                                setClickSendMsgFlag({});
                            }}
                        >
                            Send messages
                        </Button>
                    </Tooltip>
                </div>
            </div>
            {showGreetBanner && !showGroupPracticeView && (
                <div className={s.greetBanner}>
                    <div className={s.greetBannerContent}>
                        <div className={s.gleft}>
                            <img src={ThumbsUpIcon} width={56} height={54} />
                        </div>
                        <div className={s.gmid}>
                            <div className={s.m1}>Set up automated new patient greetings</div>
                            <div className={s.m2}>
                                Welcome new patients with a personal touch. Send an automated greeting message to every
                                new patient after their first visit is booked.
                            </div>
                            <div className={s.m3}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M11 3C11 2.44772 10.5523 2 10 2C9.44771 2 9 2.44772 9 3V4C9 4.55228 9.44771 5 10 5C10.5523 5 11 4.55228 11 4V3Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M15.6568 5.75731C16.0473 5.36678 16.0473 4.73362 15.6568 4.34309C15.2663 3.95257 14.6331 3.95257 14.2426 4.34309L13.5355 5.0502C13.145 5.44072 13.145 6.07389 13.5355 6.46441C13.926 6.85494 14.5592 6.85494 14.9497 6.46441L15.6568 5.75731Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M18 10C18 10.5523 17.5523 11 17 11H16C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9H17C17.5523 9 18 9.44771 18 10Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M5.05019 6.46443C5.44071 6.85496 6.07388 6.85496 6.4644 6.46443C6.85493 6.07391 6.85493 5.44074 6.4644 5.05022L5.7573 4.34311C5.36677 3.95259 4.73361 3.95259 4.34308 4.34311C3.95256 4.73363 3.95256 5.3668 4.34308 5.75732L5.05019 6.46443Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M5 10C5 10.5523 4.55228 11 4 11H3C2.44772 11 2 10.5523 2 10C2 9.44771 2.44772 9 3 9H4C4.55228 9 5 9.44771 5 10Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M8 16V15H12V16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16Z"
                                        fill="#60A5FA"
                                    />
                                    <path
                                        d="M12.0009 14C12.0155 13.6597 12.2076 13.3537 12.4768 13.1411C13.4046 12.4086 14 11.2738 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 11.2738 6.59545 12.4086 7.52319 13.1411C7.79241 13.3537 7.98451 13.6597 7.99911 14H12.0009Z"
                                        fill="#60A5FA"
                                    />
                                </svg>
                                Providers who set up greetings see <b> 27% more patient engagement </b> before the first
                                visit.
                            </div>
                        </div>
                        <div className={s.gright}>
                            <div className={s.btnWrap}>
                                <Button onClick={handleSkip} className={s.btn}>
                                    Skip for now
                                </Button>
                                <Button
                                    onClick={() => {
                                        setShowGreetingSetUpModal(true);
                                    }}
                                    className={s.btn}
                                    type="primary"
                                >
                                    Set up now
                                </Button>
                            </div>
                            <div className={s.imgWrap}>
                                <img src={R3Img} className={s.im1} width={135} height={130} />
                                <img src={R1Img} className={s.im2} width={54} height={49} />
                                <img src={R2Img} className={s.im3} width={112} height={114} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className={`${s.content} ${showGreetBanner && !showGroupPracticeView ? s.contentGreetBanner : ''}`}>
                <MessageContainer
                    clickSendMsgFlag={clickSendMsgFlag}
                    showGroupPracticeView={showGroupPracticeView}
                    gpViewAsProviderId={selectedProviderIdForView}
                />
            </div>

            <Modal
                open={showAvaModal}
                footer={null}
                width="960px"
                onCancel={() => {
                    setShowAvaModal(false);
                }}
            >
                <div className={s.avaWrap}>
                    <div className={s.left}>
                        <img src={Frame} />
                    </div>
                    <div className={s.right}>
                        <div className={s.header}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                            >
                                <path
                                    d="M19.9996 39.13C30.565 39.13 39.13 30.565 39.13 19.9996C39.13 9.43415 30.565 0.869141 19.9996 0.869141C9.43415 0.869141 0.869141 9.43415 0.869141 19.9996C0.869141 30.565 9.43415 39.13 19.9996 39.13Z"
                                    fill="#F0FCF6"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0 20C0 8.95432 8.95432 0 20 0C31.0457 0 40 8.95432 40 20C40 31.0457 31.0457 40 20 40C8.95432 40 0 31.0457 0 20ZM20 1.73913C9.91482 1.73913 1.73913 9.91482 1.73913 20C1.73913 30.0852 9.91482 38.2609 20 38.2609C30.0852 38.2609 38.2609 30.0852 38.2609 20C38.2609 9.91482 30.0852 1.73913 20 1.73913Z"
                                    fill="#00816B"
                                />
                                <path
                                    d="M30.9316 24.0999C32.8882 24.0999 34.12 22.7668 34.12 20.8103C34.12 18.8537 32.8882 17.2676 30.9316 17.2676V20.9115V24.0999Z"
                                    fill="#A3CDC3"
                                />
                                <path
                                    d="M9.52344 17.2673C7.56687 17.2673 6.33511 18.6003 6.33511 20.5569C6.33511 22.5135 7.56687 24.0996 9.52344 24.0996V20.4557V17.2673Z"
                                    fill="#A3CDC3"
                                />
                                <path
                                    d="M8.9668 15.1323C8.9668 13.8517 10.005 12.8135 11.2856 12.8135H29.4223C30.7029 12.8135 31.7411 13.8517 31.7411 15.1323V26.8922C31.7411 28.1728 30.7029 29.211 29.4223 29.211H11.2856C10.005 29.211 8.9668 28.1728 8.9668 26.8922V15.1323Z"
                                    fill="#00816B"
                                />
                                <path d="M19.0898 9.97949H21.8228V13.6234H19.0898V9.97949Z" fill="#00816B" />
                                <path
                                    d="M10.8906 16.853C10.8906 15.5724 11.9288 14.5342 13.2095 14.5342H27.7022C28.9829 14.5342 30.0211 15.5724 30.0211 16.853V24.969C30.0211 26.2496 28.9829 27.2878 27.7022 27.2878H13.2095C11.9288 27.2878 10.8906 26.2496 10.8906 24.969V16.853Z"
                                    fill="white"
                                />
                                <path
                                    d="M24.1499 22.1256C24.5413 22.1256 24.8585 21.6498 24.8585 21.0628C24.8585 20.4758 24.5413 20 24.1499 20C23.7586 20 23.4414 20.4758 23.4414 21.0628C23.4414 21.6498 23.7586 22.1256 24.1499 22.1256Z"
                                    fill="#00816B"
                                />
                                <path
                                    d="M18.4824 23.1885C19.1119 23.6082 19.8515 23.8321 20.608 23.8321C21.3646 23.8321 22.1042 23.6082 22.7336 23.1885"
                                    fill="#00816B"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M18.12 22.9475C18.2532 22.7478 18.5231 22.6938 18.7229 22.827C19.2809 23.199 19.9366 23.3976 20.6073 23.3976C21.278 23.3976 21.9337 23.199 22.4917 22.827C22.6915 22.6938 22.9615 22.7478 23.0947 22.9475C23.2279 23.1473 23.1739 23.4173 22.9741 23.5505C22.2732 24.0178 21.4497 24.2671 20.6073 24.2671C19.7649 24.2671 18.9414 24.0178 18.2405 23.5505C18.0407 23.4173 17.9867 23.1473 18.12 22.9475Z"
                                    fill="#00816B"
                                />
                                <path
                                    d="M17.064 22.1256C17.4553 22.1256 17.7725 21.6498 17.7725 21.0628C17.7725 20.4758 17.4553 20 17.064 20C16.6727 20 16.3555 20.4758 16.3555 21.0628C16.3555 21.6498 16.6727 22.1256 17.064 22.1256Z"
                                    fill="#00816B"
                                />
                                <path
                                    d="M23.6444 9.06804C23.6444 10.0743 22.2169 10.89 20.456 10.89C18.6951 10.89 17.2676 10.0743 17.2676 9.06804C17.2676 8.06181 18.6951 7.24609 20.456 7.24609C22.2169 7.24609 23.6444 8.06181 23.6444 9.06804Z"
                                    fill="#A3CDC3"
                                />
                            </svg>
                            <div className={s.hRight}>
                                <div className={s.title}>Ava auto-reply</div>
                                <div className={s.des}>Created by Klarity Health</div>
                            </div>
                        </div>
                        <span className={s.label}>New feature</span>
                        <div className={s.avaTitle}>
                            Meet <img className={s.ava} src={AvaIcon} />, your AI prospect assistant
                        </div>
                        <div className={s.avaDes}>
                            Ava helps you respond to clients instantly, boosting your response rate and saving you time.
                            Customize her tone, add your booking link, then you're all set. Let Ava handle the initial
                            communication while you focus on what you do best – providing excellent care.
                        </div>
                        <div className={s.btnWrap}>
                            <Button
                                onClick={() => {
                                    setShowAvaHome(true);
                                }}
                                block
                                size="large"
                                className={s.btn}
                            >
                                Learn more
                            </Button>
                            <Button
                                onClick={() => {
                                    setHasShowAvaSettingInbox(true);
                                    navigate(`${PATH.DASHBOARD}/${PATH.AVA_SETTING}`);
                                }}
                                block
                                size="large"
                                type="primary"
                                className={s.btn}
                            >
                                Set up Ava in Settings
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
            <AvaConfigHome
                show={showAvaHome}
                onClickBack={() => {
                    setShowAvaHome(false);
                }}
                onClickSet={() => {
                    setHasShowAvaSettingInbox(true);
                    setShowAvaHome(false);
                    navigate(`${PATH.DASHBOARD}/${PATH.AVA_SETTING}?from=inbox`);
                }}
            />
            <div className={commonS.chatWrap}>
                <AIChat pageId={EAIChatPageId.PROVIDER_MESSAGE} defaultShow={false} makeFix={false} />
            </div>
            <GreetingSetUpModal
                show={showGreetingSetUpModal}
                defaultType="tips"
                onCannel={() => {
                    setShowGreetingSetUpModal(false);
                }}
                onSuccess={() => {
                    setShowGreetBanner(false);
                    handleSkip();
                }}
            />
        </div>
    );
};

export default InboxPage;
